var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ScrollSelect", {
    ref: "ScrollSelect",
    attrs: {
      api: _vm.api,
      placeholder: _vm.$t("chooseText"),
      multiple: _vm.multiple,
      disabled: _vm.disabled,
      size: _vm.size,
      "default-params": _vm.defaultParams,
      "default-options": _vm.defaultOptions,
      remote: _vm.remote,
      "no-data-text": _vm.$t("table.emptyText"),
      "search-key": "name",
      "option-label": "name",
      "option-enabled": "enableFlag",
      "option-value": "id",
      "res-key": "content",
    },
    on: { change: _vm.onChange },
    model: {
      value: _vm.id,
      callback: function ($$v) {
        _vm.id = $$v
      },
      expression: "id",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }